export enum NavigationMenuTypeEnum {
    NotSet = 0,
    HospitalLevel = 1,
    SingleHospital = 2,
    FullMenu = 3
}
